import { createContext, useContext, useEffect, useMemo, useState } from 'react'

const Context = createContext<number>(0)

type SubmitCountProviderProps = {
  children?: React.ReactNode
  initialValue?: number
  submitCount?: number
}

const SubmitCountProvider: React.FC<SubmitCountProviderProps> = ({ children, initialValue, submitCount = 0 }) => {
  const [count, setCount] = useState<number>(initialValue || 0)

  useEffect(() => {
    setCount((prev) => Math.max(submitCount, prev))
  }, [submitCount])

  const value = useMemo(() => {
    return count
  }, [count])

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useSubmitCount = (): number | undefined => {
  const context = useContext(Context)

  return context
}

export default SubmitCountProvider
